import Vue from 'vue';
import mgr from './security.js'
import Vuex from 'vuex'


Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    //auth
    isAuthenticated: false,
    user: null,
    streamingWebMgr: mgr,
    //core
    navdrawer: true,
    navigationDrawerWidth: 300,
    windowSize:{
      x:0,
      y:800
    },
    //list
    searchquery: '',
    resources: [],
    resourcesFiltered: [],
    activeItems: [],
    //streaming
    resource:{
        bd:'', 
        id: '', 
        name:'', 
        operation: ''
    },
    resourcesLoading: true,
    cameraIndex: 0,
    //
    markerDragging: false,
    markerInfo: {
      id: undefined,
      name:undefined
    },
    playerHovered: undefined,
    hasMap: true,
    camerasInDisplay:1
  },
  mutations: {
    //auth  
    userAuthenticated(state,userRequest) {
        state.isAuthenticated = true
        state.user = userRequest
    },
    notAuthenticated(state) {
        state.isAuthenticated = false
    },
    setUser(state,value){
      state.user = value
    },
    //core
    setMobile(state,value){
      state.mobile = value
    },
    setDrawer(state,value) {
      state.navdrawer = value
    },
    setWindowSize(state,value){
      state.windowSize = value
    },
    setNavigationDrawerWidth(state,value){
      state.navigationDrawerWidth = value
    },
    //streaming
    setResource(state,value){
      if(state.resource.id !== value.id){
        state.resource = value
      } else if(state.resource.operation !== value.operation) {
        state.resource = value
      }
    },
    setResourcesLoading(state,value){
        state.resourcesLoading = value
    },
    setHasMap(state,value){
      state.hasMap = value
    },
    setIndex(state,value){
      state.cameraIndex = value
    },
    //list
    setSearchQuery(state,value){
        state.searchquery = value
    },
    setResources(state,value){
      state.resources = value
    },
    setActiveItems(state,value){
      state.activeItems = value
    },
    //
    setMarkerDragging(state,value){
      state.markerDragging = value
    },
    setPlayerHovered(state,value){
      state.playerHovered = value
    },
    setCamerasInDisplay(state,value){
      state.camerasInDisplay = value
    }
  },
  getters: {
    //auth
    getAccessToken: (state)=>{
      return state.user.access_token
    },  
    //core
    getDrawer: (state)=> {
      return state.navdrawer
    },
    getWindowSize: (state)=>{
      return state.windowSize
    },
    getMobile: (state)=>{
      return state.mobile
    },
    getNavDrawerHeight: (state,getters)=>{
      if(!getters.getMobile){ 
        var toolbar_footer_heightPercentage= (48 / window.innerHeight)
        return state.windowSize.y - (state.windowSize.y * toolbar_footer_heightPercentage)
      } else {
        return state.windowSize.y/2
      }
    },
    getNavigationDrawerWidth: (state)=>{
      return state.navigationDrawerWidth
    },
    //streaming
    getResource: (state)=>{
        return state.resource
    },
    getResourcesLoading: (state)=>{
        return state.resourcesLoading
    },
    getMaxCameras: (state)=>{
      return (state.hasMap)? 3 : 4
    },
    getCameraIndex: (state)=>{
      return (state.cameraIndex)
    },
    //list
    getSearchQuery: (state)=>{
      return state.searchquery
    },
    getResources(state) {
      return state.resources
    },
    getActiveItems(state) {
      return state.activeItems
    },
    //map
    getMarkerDragging: (state)=> {
      return state.markerDragging
    },    
    getMarkerInfo: (state)=> {
      return state.markerInfo
    },
    getPlayerHovered(state){
      return state.playerHovered
    } ,
    getCamerasInDisplay(state){
      return state.camerasInDisplay
    }   
  },
  actions: {
    //auth
    async authenticate({dispatch, commit},returnPath) {
        const userRequest = await dispatch('getUser'); //see if the user details are in local storage
        if (userRequest) {
            commit('userAuthenticated',userRequest);
        } else {
            await dispatch('signIn',returnPath);
        }
      },
    async getUser ({state}) {
        try {
            let userRequest = await state.streamingWebMgr.getUser()
            return userRequest;
        } catch (err) {
            console.log("error resolving user", err)
            return;
        }
    },
    signIn ({state},returnPath) {
        if(returnPath) {
            state.streamingWebMgr.signinRedirect({ status: returnPath })
        } else {
            state.streamingWebMgr.signinRedirect();
        }
    },
    async signinRedirectCallback({state,commit}){
        commit('setUser',await state.streamingWebMgr.signinRedirectCallback());
        return state.user;
    },
    async signOut({state}){
        await state.streamingWebMgr.signoutRedirect()
    },

    setResourceFromMap({state,commit},value){
      var index = state.activeItems.findIndex(res=> res === value.id)
      if(index > -1){
        commit('setResource', {id: value.id, name:value.name, operation:"remove"})
      } else {
        //commit('setResource', {id: value.id, name:value.name, operation:"add"})
        state.activeItems.splice(state.activeItems.length,0,value.id)
        
      }
    },
    setMarkerInfo({state,commit},value){
      state.markerInfo.id = value.id
      state.markerInfo.name = value.name
      commit('setMarkerDragging',true)
    },
    setOffMarkerDragging({state,commit}){
      state.markerInfo.id=undefined
      state.markerInfo.name = undefined
      commit('setMarkerDragging',false)
    }
  }
})

export default store